const bcLoginState: bcState = {
  name: 'app-login',
  url: 'login'
};

const bcLogoutState: bcState = {
  name: 'bc-logout',
  url: 'logout'
};

const bcSsoState: bcState = {
  name: 'bc-sso',
  url: 'sso/:paramType/:paramValue'
};

const bcSsoErrorState: bcState = {
  name: 'bc-sso-error',
  url: 'sso-error'
};

const bcRootState: bcState = {
  name: 'bc-root'
};

const bcLayoutState: bcState = {
  name: 'bc-layout',
  url: 'work'
};

const queueViewState: bcState = {
  name: 'app-queue-view',
  url: 'monitor'
};

const recordingsState: bcState = {
  name: 'app-recordings',
  url: 'recordings'
};

const permissionDeniedState: bcState = {
  name: 'app-permission-denied',
  url: 'permission-denied'
}

export const bcStates: { [key: string]: bcState } = {
  root: bcRootState,
  layout: bcLayoutState,
  login: bcLoginState,
  logout: bcLogoutState,
  sso: bcSsoState,
  ssoError: bcSsoErrorState,
  recordingsList: recordingsState,
  queueView: queueViewState,
  permissionDenied: permissionDeniedState
};

export interface bcState {
  name: string;
  url?: string;
}
